'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msSleepEntryDone', {
    templateUrl: 'sleep/templates/sleep-entry-done.html',
    controller: SleepEntryDone,
    controllerAs: 'vm',
    bindings: {
      /* <string> date in format YYYY-MM-DD */
      day: '<',
      /* <object> a saved SleepEntry to summarize */
      entry: '<'
    }
  });
  SleepEntryDone.$inject = ['$log'];

  /* @ngInject */
  function SleepEntryDone($log) {
    var vm = this;
    vm.$onInit = function () {
      $log.debug('SleepEntryDone activate');
    };
  }
})();